import { render, staticRenderFns } from "./SchedulesPricing.vue?vue&type=template&id=218d9cb9&"
import script from "./SchedulesPricing.vue?vue&type=script&lang=ts&"
export * from "./SchedulesPricing.vue?vue&type=script&lang=ts&"
import style0 from "./SchedulesPricing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports